<ng-container *ngIf="pressReviews">
  <div
    class="reviews-header header-msg title"
    [attr.data-translate]="'public.commons.reviews'"
    i18n="@@public.commons.reviews"
  >
    Reviews
  </div>
  <div class="reviews-container movie-detail-section">
    <a
      *ngFor="let review of pressReviews"
      [href]="review.url ? review.url : ''"
      class="review-item {{ review.url ? 'pointer' : '' }}"
      target="_blank"
    >
      <div class="review-rating" *ngIf="review.rating">
        <i *ngFor="let star of numToArray(review.rating)" class="pi pi-star" style="font-size: 1rem"></i>
      </div>
      <div class="review-item-quote subtitle" *ngIf="review.quote">{{ review.quote }}</div>
      <div class="review-item-source" *ngIf="review.press?.name" [innerHTML]="review.press.name | safe: 'html'"></div>
    </a>
  </div>
</ng-container>
